import { Check, MapPin } from 'lucide-react';
import { WhatsAppCta } from '@/components/home/WhatsAppCta';
import { HOME } from '@/constants/testIds';

export const FinalCTA = () => (
  <section className="gg-section gg-final" data-testid="final-booking-section">
    <div className="gg-container gg-final-grid">
      <div><p className="gg-eyebrow">MULA DENGAN SITE VISIT</p><h2 data-testid="final-booking-heading">Rumah berbeza. Cadangan CCTV pun patut berbeza.</h2><p className="gg-final-description" data-testid="final-booking-description">Hantar lokasi dan jenis rumah anda. Kami bantu semak sudut kamera, pakej dan slot site visit yang sesuai.</p><p className="gg-final-area" data-testid="final-service-area"><MapPin size={16} />Sg Buloh · Damansara · KL · Selangor</p></div>
      <div className="gg-final-action"><WhatsAppCta testId={HOME.finalWhatsappCta} booking /><div className="gg-final-reassurance" data-testid="final-booking-reassurance"><span><Check size={14} />Site visit percuma di Lembah Klang</span><span><Check size={14} />Quotation dahulu, tanpa komitmen</span></div></div>
    </div>
  </section>
);

export default FinalCTA;